import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const ReceiptsTextBlock = (): JSX.Element => {
  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
    >
      <HeadingAndSupportingText
        gap='spacing-3xl'
        heading={{
          type: 'heading',
          text: 'Receipts.',
          size: 'xl',
          textAlign: 'center',
        }}
        supportingText={{
          type: 'paragraph',
          text: 'Real numbers from real people.',
          size: 'xl',
          color: 'text-tertiary',
          textAlign: 'center',
        }}
      />
    </Stack>
  );
};

export default ReceiptsTextBlock;
